import {
    SYSTEM_GET_AREA_LIST_BEGIN,
    SYSTEM_GET_AREA_LIST_SUCCESS,
    SYSTEM_GET_AREA_LIST_FAILURE,
    SYSTEM_GET_AREA_LIST_DISMISS_ERROR,
  } from './constants';
  
  import request from '../../../utils/request'
  // Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
  // If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
  export function getAreaList(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: SYSTEM_GET_AREA_LIST_BEGIN,
      });
     params.size = 10;

     const promise = new Promise((resolve, reject) => {
          request({
            method:'get',
            url:'/v2/admin/area/list',
            data:params,
          }).then( data => {
              dispatch({
                  type: SYSTEM_GET_AREA_LIST_SUCCESS,
                  data: Object.assign({},data,{page:params.page}),
              });
              resolve(data);
          }).catch (error => {
              dispatch({
                type: SYSTEM_GET_AREA_LIST_FAILURE,
                data: { error: error },
              });
              reject(error);
          })
      });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissGetAreaListError() {
    return {
      type: SYSTEM_GET_AREA_LIST_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case SYSTEM_GET_AREA_LIST_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          getAreaListPending: true,
          getAreaListError: null,
        };
  
      case SYSTEM_GET_AREA_LIST_SUCCESS:
        // The request is success
  
        const byId = {};
        const items = [];
        action.data.list.forEach(item => {
          items.push(item.id);
          byId[item.id] = item;
        });
        return {
          ...state,
          areaById:byId,
          areaList:items,
          areaPage: action.data.page,
          areaSize: action.data.size,
          areaTotal: action.data.count,
          getAreaListPending: false,
          getAreaListError: null,
        };
  
      case SYSTEM_GET_AREA_LIST_FAILURE:
        // The request is failed
        return {
          ...state,
          getAreaListPending: false,
          getAreaListError: action.data.error,
        };
  
      case SYSTEM_GET_AREA_LIST_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          getAreaListError: null,
        };
  
      default:
        return state;
    }
  }


// WEBPACK FOOTER //
// ./src/features/system/redux/getAreaList.js